import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import { phaserGameConfig } from '../game/settings/phaser-game-config-specifications';
import './Home.css';
import Phaser from "phaser";

const Home: React.FC = () => {
  
  new Phaser.Game(phaserGameConfig);

  return (
    <>
      <div id="phaser_game" style={{background: "#121212"}}> </div>
    </>
  // style={{color: "red"}}
    // <IonPage>
    //   <IonContent fullscreen>
    //     <div id="phaser_game"> </div>
    //   </IonContent>

      // {
        /* <IonHeader>
        <IonToolbar>
          <IonTitle>Blank</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Blank</IonTitle>
          </IonToolbar>
        </IonHeader>
        <ExploreContainer />
      </IonContent> */
    // }
    // </IonPage>
  );
};

export default Home;
